// test2893
(2893 && 0);
